export const baseRoute = '/o/:orgId';

export const mailroomWelcomeRoute = 'welcome';

export const mailroomDashboardRoute = 'dashboard';

export const mailroomListRoute = 'mailrooms';

export const parcelActivityRoute = 'mailroomParcelActivity';

export const rolesRoute = 'roles';

export const releaseNotesRoute = 'releaseNotes';
